import { PlatformLocation } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { AtualizarProdutosModalComponent } from '../modals/atualizar-produtos-modal/atualizar-produtos-modal.component';
import { PontosFidelidadeModalComponent } from '../modals/pontos-fidelidade-modal/pontos-fidelidade-modal.component';
import { ProdutoFidelidadeModalComponent } from '../modals/produto-fidelidade-modal/produto-fidelidade-modal.component';
import { FornecedoresEstrutura } from '../models/fornecedores-estrutura';
import { Funcionario } from '../models/funcionario';
import { Premissas } from '../models/premissas';
import { TesteEmail } from '../models/teste-email';
import { Variavel } from '../models/variavel';
import { AutenticacaoService } from '../services/autenticacao.service';
import { CarregandoService } from '../services/carregando.service';
import { EmailService } from '../services/email.service';
import { FuncionarioService } from '../services/funcionario.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { UtilitarioService } from '../services/utilitario.service';
import { VariaveisService } from '../services/variaveis.service';
import { CnaeModalComponent } from '../modals/cnae-modal/cnae-modal.component';
import { ArquivoPropostaModalComponent } from '../modals/arquivo-proposta-modal/arquivo-proposta-modal.component';
import { ArquivoTermoModalComponent } from '../modals/arquivo-termo-modal/arquivo-termo-modal.component';
import { TemplateEmailService } from '../services/template-email.service';
import { FaixaFreteModalComponent } from '../modals/faixa-frete-modal/faixa-frete-modal.component';
import { ArquivoResumoPedidoModalComponent } from '../modals/arquivo-resumo-pedido-modal/arquivo-resumo-pedido-modal.component';
import { ItemConversaModalComponent } from '../modals/item-conversa-modal/item-conversa-modal.component';
import { QuestionarioEntregaModalComponent } from '../modals/questionario-entrega-modal/questionario-entrega-modal.component';
import { ItemSimuladorFinanceiro } from 'src/app/models/item-simulador-financeiro';
import { Marca } from '../models/marca';
import { MarcaService } from '../services/marca.service';
import { ItemSimFinModalComponent } from '../modals/item-sim-fin-modal/item-sim-fin-modal.component';
import { SignatariosModalComponent } from '../modals/signatarios-modal/signatarios-modal.component';
import { ContaRefModalComponent } from '../modals/conta-ref-modal/conta-ref-modal.component';
import { IdentidadeVisualService } from '../services/identidade-visual.service';
import { UsuarioLogado } from '../models/usuario-logado';
import { PremissasSistema } from '../models/premissas-sistema';
import { Etapa } from '../models/etapa';
import { EtapaService } from '../services/etapa.service';
import { EtapaDoPedido, OrigemGI, TipoCalculoMarkup, TipoFiltroProduto, VersaoApiImposto } from '../models/enum';
import { TransferenciaItemsVendedorModalComponent } from '../modals/transferencia-items-vendedor-modal/transferencia-items-vendedor-modal.component';
import { PremissasUsuario } from '../models/premissas-usuario';
import { ClienteService } from '../services/cliente.service';
import { PrecificacaoUFModalComponent } from '../modals/precificacao-ufmodal/precificacao-ufmodal.component';
import { FaixaDescargaCifComponent } from '../modals/faixa-descarga-cif/faixa-descarga-cif.component';
import { CacheService } from '../services/cache-service';
import { IndicadoresAnaliseDescontoModalComponent } from '../modals/indicadores-analise-desconto-modal/indicadores-analise-desconto-modal.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-premissas',
  templateUrl: './premissas.component.html',
  styleUrls: ['./premissas.component.scss']
})
export class PremissasComponent implements OnInit, AfterViewInit {
  premissas = new Premissas();
  premissasSistema = new PremissasSistema();
  premissasUsuario = new PremissasUsuario();

  visualizacoesKitFechado = [
    { id: 0, descricao: 'Cards' },
    { id: 1, descricao: 'Lista' },
    { id: 2, descricao: 'Agrupamento Painel e Inversor' }
  ];

  regrasValidacaoKitPersonalizado = [
    { id: 0, descricao: 'Inversor e Painel' },
    { id: 1, descricao: 'Inversor ou Painel' }
  ];

  origens = [
    { id: OrigemGI.KitCustomizado, descricao: 'Monte seu kit' },
    { id: OrigemGI.KitFechado, descricao: 'Kit pronto' },
    { id: OrigemGI.Avulso, descricao: 'Avulso' },
    { id: OrigemGI.LojaProdutos, descricao: 'Loja de produtos' }
  ];

  editando = false;
  carregando = true;

  cSSL = false;
  cTLS = false;

  public MASKS = MASKS;
  editavel = true;

  tabAlvo = 0;
  tabIndex = 0;

  hide = true;

  marcas: Marca[] = [];

  variaveis: Variavel[] = [];
  grupos: string[] = [];
  variavelSelecionada: Variavel;

  usuarioLogado: UsuarioLogado;

  podeUsarFreteIndividualServico = false;

  configuracaoTexto: any = {
    lang: 'pt-BR',
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontsize']],
      ['para', ['ul', 'oj']],
      ['paragraph'],
      ['code', ['codeview']],
      //['mybutton', ['vars']],
      ['insert', ['link', 'picture']],
      ['testBtn']
      // ['template', ['importar']],
      // ['anexo', ['btnfile']]
    ],
    height: '300px',
    placeholder: 'Digite aqui a assinatura do email...',
    buttons: {
      testBtn: (context) => {
        const ui = $.summernote.ui;
        const button = ui.button({
          contents: 'Variáveis',
          tooltip: 'Variáveis',
          container: '.note-editor',
          className: 'note-btn',
          click: () => {
            this.variavelSelecionada = undefined;
            context.invoke('saveRange');
            $('#modalVariaveis').modal({});

            $('#modalVariaveis').on('hidden.bs.modal', (e) => {
              if (this.variavelSelecionada) {
                context.invoke('restoreRange');
                context.invoke('focus');
                context.invoke('editor.insertText', this.variavelSelecionada.texto);
              }
              $('#modalVariaveis').off('hidden.bs.modal');
            });
          }
        });
        return button.render();
      }
    }
  };
  dados = new FornecedoresEstrutura();
  estruturas = [
    {
      id: 0,
      nome: 'Alfix'
    },
    {
      id: 1,
      nome: 'PhotoEnergy'
    },
    {
      id: 2,
      nome: 'Go Solar'
    },
    {
      id: 3,
      nome: 'Fotus'
    },
    {
      id: 4,
      nome: 'Romagnole'
    },
    {
      id: 5,
      nome: 'Brassunny'
    },
    {
      id: 6,
      nome: 'SSM'
    },
    {
      id: 7,
      nome: 'LB Solar'
    },
    {
      id: 8,
      nome: 'Viener'
    },
    {
      id: 9,
      nome: 'CCM'
    },
    {
      id: 10,
      nome: 'Romagnole'
    },
    {
      id: 11,
      nome: 'Belle System'
    },
    {
      id: 12,
      nome: 'Pratyc'
    },
    {
      id: 13,
      nome: 'E3'
    },
    {
      id: 14,
      nome: 'Solar Group'
    },
    {
      id: 15,
      nome: 'Vertys'
    },
    {
      id: 16,
      nome: 'Vertys 4'
    },
    {
      id: 17,
      nome: 'Vertys 8'
    },
    {
      id: 18,
      nome: 'K2'
    }
  ];
  regras = [
    {
      id: 1,
      nome: 'Desconto'
    },
    {
      id: 2,
      nome: 'Valor Venda'
    }
  ];

  optionsAssign = [
    { id: 0, descricao: 'Cadastro do Integrador' },
    { id: 1, descricao: 'Primeiro Pedido' }
  ];

  opcoesBloqueioAutomatico = [
    {
      qtdDias: 0,
      descricao: 'Nunca'
    },
    {
      qtdDias: 30,
      descricao: '1 mês'
    },
    {
      qtdDias: 90,
      descricao: '3 meses'
    },
    {
      qtdDias: 180,
      descricao: '6 meses'
    }
  ];

  vendedores: Funcionario[] = [];
  selectedFile: File;
  suporte = false;

  templatesEmail = [];

  itensSimFin: ItemSimuladorFinanceiro[] = [];

  ordenarDesc = false;
  campoOrdenacao = 'wp';

  identidadeVisual: any = {
    urlLogo: '',
    urlBackground: '',
    urlAppIcon: '',
    domain: [],
    cores: {
      corPrincipal: '',
      corDefault: '',
      corPrimary: '',
      corInfo: '',
      corSuccess: '',
      corWarning: '',
      corDanger: '',
      corRose: '',
      corGraficos: '',
      usarCorSecundariaNosBotoes: false
    }
  };

  modulosAtivos: Number[] = [];
  administrador: boolean = false;
  bloquearSistema: boolean = false;

  listaEtapasGeracao: Etapa[] = [];
  tiposEnderecoEntrega = [
    // Desabilitado até a organização lógica do modal digita-campo
    //{ id: 0, descricao: 'Nenhum' },
    //{ id: 1, descricao: 'Integrador' },
    //{ id: 2, descricao: 'Venda direta' },
    { id: 3, descricao: 'Auto sugestão' }
  ];

  tiposCalculoMarkup = [
    { id: TipoCalculoMarkup.Simples, descricao: 'Simples' },
    { id: TipoCalculoMarkup.Composto, descricao: 'Composto' }
  ];

  tiposComSemStringBox = [
    { valor: true, descricao: 'Com string box' },
    { valor: false, descricao: 'Sem string box' }
  ];

  tiposRastreamento = [
    { id: 0, descricao: 'Nenhum' },
    { id: 1, descricao: 'Interno' },
    { id: 2, descricao: 'Externo' }
  ];

  prazosAtualizacaoReceitaFederal = [
    { id: 0, descricao: 'Nenhum' },
    { id: 15, descricao: '15 dias' },
    { id: 30, descricao: '30 dias' },
    { id: 45, descricao: '45 dias' },
    { id: 60, descricao: '60 dias' },
    { id: 60, descricao: '75 dias' },
    { id: 90, descricao: '90 dias' }
  ];

  ordenacoesOrcPed = [
    { id: 0, descricao: 'Mais recente' },
    { id: 1, descricao: 'Data hora orçamento/pedido' }
  ];

  versoesApiImposto = [
    { id: VersaoApiImposto.V1, descricao: 'V1' },
    { id: VersaoApiImposto.V2, descricao: 'V2' }
  ];

  exemploLink = 'Variáveis: {numeroPedido} | {codErp} | {numeroNfe} | {chaveNfe}';

  itensFiltroProdutos = [
    { id: TipoFiltroProduto.Agrupamento, descricao: 'Agrupamento' },
    { id: TipoFiltroProduto.Categoria, descricao: 'Categoria' }
  ];

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private premissasService: PremissasService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private autenticacaoService: AutenticacaoService,
    private emailService: EmailService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private platformLocation: PlatformLocation,
    private variaveisService: VariaveisService,
    private funcionarioService: FuncionarioService,
    private templateEmailService: TemplateEmailService,
    private marcaService: MarcaService,
    private identidadeVisualService: IdentidadeVisualService,
    private etapaService: EtapaService,
    private clienteService: ClienteService,
    private cacheService: CacheService
  ) {}

  async ngOnInit() {
    this.usuarioLogado = await this.globalService.consultaUsuario();

    this.editando = true;
    // this.premissas.cadIntFisico = true;
    // this.premissas.tipoCalculo = 0;
    this.suporte = await this.globalService.suporte();
    this.administrador = await this.globalService.administrador();
    this.buscarPremissas();
    this.buscarVariaveis();
    this.buscarVendedores();
    this.buscarTemplatesEmail();
    this.buscarMarcas();
    this.buscarIdentidadeVisual();
    this.buscarModulosAtivos();
    this.buscarPremissasBloqueioSistema();

    if (this.suporte || this.administrador) {
      this.buscarEtapas();
      this.buscarPremissasSistema();
    }

    this.buscarUsarFreteIndividualServico();

    this.buscarPremissasUsuario();
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde('buscarBloqSist');
      },
      (erro) => {
        this.carregandoService.esconde('buscarBloqSist');
        this.notificacaoService.erro(erro);
      }
    );
  }

  filtrarVariaveis(grupo) {
    return this.variaveis.filter((p) => p.grupo === grupo);
  }

  selecionarVariavel(variavel: Variavel) {
    this.variavelSelecionada = variavel;
    $('#modalVariaveis').modal('hide');
  }

  buscarTemplatesEmail() {
    this.carregandoService.mostra('buscarTemplatesEmail');

    this.templateEmailService.consultarTemplates().subscribe(
      (dados) => {
        this.templatesEmail = dados;
        this.carregandoService.esconde('buscarTemplatesEmail');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTemplatesEmail');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarUsarFreteIndividualServico() {
    this.carregandoService.mostra('buscarUsarFreteIndividualServico');

    this.premissasService.consultarUsarFreteIndividualServico().subscribe(
      (dados) => {
        this.podeUsarFreteIndividualServico = dados.valor;
        this.carregandoService.esconde('buscarUsarFreteIndividualServico');
      },
      (erro) => {
        this.carregandoService.esconde('buscarUsarFreteIndividualServico');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.consultarMarcas().subscribe(
      (marcs) => {
        this.marcas = marcs;

        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarIdentidadeVisual() {
    this.carregandoService.mostra('buscarIdentidadeVisual');

    this.identidadeVisualService.consultarIdentidadeVisual().subscribe(
      (identidadeVisual) => {
        this.identidadeVisual = identidadeVisual;

        this.carregandoService.esconde('buscarIdentidadeVisual');
      },
      (erro) => {
        this.carregandoService.esconde('buscarIdentidadeVisual');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarVariaveis() {
    this.carregandoService.mostra('buscarVariaveis');

    this.variaveisService.consultarVariaveis().subscribe(
      (vars) => {
        this.variaveis = vars;
        this.grupos = [...new Set(this.variaveis.map((p) => p.grupo))];
        this.grupos.splice(this.grupos.indexOf('Contato'), 1);
        this.carregandoService.esconde('buscarVariaveis');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVariaveis');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissas() {
    this.carregandoService.mostra('buscarPremissas');

    this.premissasService.consultarPremissas().subscribe(
      (emp) => {
        this.premissas = emp;
        this.atualizaDadosPremissas();
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');

    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;
        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissasUsuario() {
    this.carregandoService.mostra('buscarPremissasUsuario');

    this.premissasService.consultarPremissasUsuario().subscribe(
      (premissas) => {
        this.premissasUsuario = premissas;
        this.carregandoService.esconde('buscarPremissasUsuario');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasUsuario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscarEtapas');

    const etapasGeracaoPermitidas = [
      EtapaDoPedido.AguardandoIntegracao,
      EtapaDoPedido.AguardandoPagamentoRecursoProprio,
      EtapaDoPedido.AguardandoTriagem,
      EtapaDoPedido.Em_Pendencia,
      EtapaDoPedido.Resolvido,
      EtapaDoPedido.AguardandoConferenciaTriagem
    ];

    this.etapaService.consultarParaFiltro().subscribe(
      (resp) => {
        this.listaEtapasGeracao = resp.filter((e) => etapasGeracaoPermitidas.includes(e.ordem));

        this.carregandoService.esconde('buscarEtapas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarEtapas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  validaDadosEmail() {
    return this.premissas.eHost && this.premissas.eUsu && this.premissas.eSenha && this.premissas.ePorta;
  }

  testarEmail() {
    this.carregandoService.mostra('testandoEmail');

    const testeEmail = new TesteEmail();
    testeEmail.host = this.premissas.eHost;
    testeEmail.porta = this.premissas.ePorta;
    testeEmail.senha = this.premissas.eSenha;
    testeEmail.ssl = this.cSSL;
    testeEmail.tsl = this.cTLS;
    testeEmail.usu = this.usuarioLogado.id;
    testeEmail.usuario = this.premissas.eUsu;

    this.emailService.testarEnvio(testeEmail).subscribe(
      (resposta) => {
        this.carregandoService.esconde('testandoEmail');
        this.notificacaoService.sucesso('Teste concluído com sucesso!!');
      },
      (erro) => {
        this.carregandoService.esconde('testandoEmail');
        this.notificacaoService.erro('Não foi possível enviar o email!!');
      }
    );
  }

  abrirContaRef() {
    const largura = Number($('body').width());
    this.dialog.open(ContaRefModalComponent, {
      width: largura > 1000 ? '950px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  abrirCnaes() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CnaeModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: { cnaes: this.premissas.cnaes },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.premissas.cnaes = res;
    });
  }

  abrirFaixasFrete() {
    const largura = Number($('body').width());

    this.dialog.open(FaixaFreteModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  abrirFaixasDescarga() {
    const largura = Number($('body').width());

    this.dialog.open(FaixaDescargaCifComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  abrirModalPrecificacaoUF() {
    const largura = Number($('body').width());

    this.dialog.open(PrecificacaoUFModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  ngAfterViewInit() {
    const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');

    // Wizard Initialization
    $('.card-wizard').bootstrapWizard({
      tabClass: 'nav nav-pills',
      nextSelector: '.btn-next',
      previousSelector: '.btn-previous',

      onNext: function (tab, navigation, index) {},

      onInit: function (tab: any, navigation: any, index: any) {
        // check number of tabs and fill the entire row
        let $total = navigation.find('li:not(.d-none)').length;
        let $wizard = navigation.closest('.card-wizard');

        let $first_li = navigation.find('li:first-child a').html();
        let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
        $('.card-wizard .wizard-navigation').append($moving_div);

        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        let $current = index + 1;

        if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
        $('.moving-tab').css('transition', 'transform 0s');
      },

      onTabClick: (tab: any, navigation: any, index: any) => {
        if (this.tabIndex !== this.tabAlvo) {
          this.tabIndex = this.tabAlvo;

          return true;
        }

        return false;
      },

      onTabShow: (tab: any, navigation: any, index: any) => {
        // this.atualizar();

        // if (index >= 3) {
        //   window.dispatchEvent(new Event('resize'));
        // }
        // this.vendedores = [...this.vendedores];

        let $total = navigation.find('li:not(.d-none)').length;
        let $current = index + 1;
        elemMainPanel.scrollTop = 0;
        const $wizard = navigation.closest('.card-wizard');

        // If it's the last tab then hide the last button and show the finish instead
        if ($current >= $total) {
          $($wizard).find('.btn-next').hide();
          $($wizard).find('.btn-finish').show();
        } else {
          $($wizard).find('.btn-next').show();
          $($wizard).find('.btn-finish').hide();
        }

        const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

        setTimeout(function () {
          $('.moving-tab').text(button_text);
        }, 150);

        const checkbox = $('.footer-checkbox');

        if (index !== 0) {
          $(checkbox).css({
            opacity: '0',
            visibility: 'hidden',
            position: 'absolute'
          });
        } else {
          $(checkbox).css({
            opacity: '1',
            visibility: 'visible'
          });
        }
        $total = $wizard.find('.nav li:not(.d-none)').length;
        let $li_width = 100 / $total;

        let total_steps = $wizard.find('.nav li:not(.d-none)').length;
        let move_distance = $wizard.width() / total_steps;
        let index_temp = index;
        let vertical_level = 0;

        let mobile_device = $(document).width() < 600 && $total > 3;

        if (mobile_device) {
          move_distance = $wizard.width() / 2;
          index_temp = index % 2;
          $li_width = 50;
        }

        $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

        let step_width = move_distance;
        move_distance = move_distance * index_temp;

        $current = index + 1;

        if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
          move_distance -= 8;
        } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
          move_distance += 8;
        }

        if (mobile_device) {
          let x: any = index / 2;
          vertical_level = parseInt(x);
          vertical_level = vertical_level * 38;
        }

        $wizard.find('.moving-tab').css('width', step_width);
        $('.moving-tab').css({
          transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
          transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
        });
      }
    });

    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.card-wizard');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    this.rodaScriptTabEnter();

    $(window).resize(() => {
      $('.card-wizard').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li:not(.d-none)').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li:not(.d-none)').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li:not(.d-none)').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && index % 2 == 0)) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && index % 2 == 1)) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $('.moving-tab').css({
            transform: 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            transition: 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $('.moving-tab').css({
            transition: 'transform 0s'
          });
        }, 500);
      });
    });

    // this.utilitarioService.rodaScriptTabEnter();
  }

  defineTabAlvo(alvo) {
    this.tabAlvo = alvo;
  }

  // atualiza o tabIndex
  proximaTab(e) {
    e.preventDefault();
    this.tabIndex++;
  }

  tabAnterior(e) {
    e.preventDefault();
    this.tabIndex--;
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosPremissas() {
    this.cSSL = this.premissas.essl === '1';
    this.cTLS = this.premissas.etls === '1';

    if (this.premissas.simFin && this.premissas.simFin !== null) {
      this.itensSimFin = JSON.parse(this.premissas.simFin);
      this.itensSimFin.forEach((p) => {
        p.detalhes = p.detalhes.replace(/<w:br\/>/g, '\n');
      });
    }

    this.carregandoService.esconde('buscarPremissas');
    this.carregando = false;
  }

  async salvar(notificar = true) {
    if (this.tabAlvo === 3) {
      this.carregandoService.mostra('salvaIdentidadeVisual');
      this.identidadeVisualService.salvarCores(this.identidadeVisual.cores).subscribe(
        () => {
          this.cacheService.clearCachedResponse();
          this.carregandoService.esconde('salvaIdentidadeVisual');
          this.notificacaoService.sucesso('Cores salvas com sucesso!!!');
        },
        (err) => {
          this.carregandoService.esconde('salvaIdentidadeVisual');
          this.notificacaoService.erro(err);
        }
      );

      return;
    }

    if (this.tabAlvo === 5) {
      try {
        if (
          this.premissasSistema.combKitLimiteInversor.monofasico === null ||
          this.premissasSistema.combKitLimiteInversor.monofasico === undefined
        )
          return;
        else
          this.premissasSistema.combKitLimiteInversor.monofasico = Number(
            this.premissasSistema.combKitLimiteInversor.monofasico
          );

        if (
          this.premissasSistema.combKitLimiteInversor.trifasico220 === null ||
          this.premissasSistema.combKitLimiteInversor.trifasico220 === undefined
        )
          return;
        else
          this.premissasSistema.combKitLimiteInversor.trifasico220 = Number(
            this.premissasSistema.combKitLimiteInversor.trifasico220
          );

        if (
          this.premissasSistema.combKitLimiteInversor.trifasico380 === null ||
          this.premissasSistema.combKitLimiteInversor.trifasico380 === undefined
        )
          return;
        else
          this.premissasSistema.combKitLimiteInversor.trifasico380 = Number(
            this.premissasSistema.combKitLimiteInversor.trifasico380
          );

        if (
          this.premissasSistema.combKitLimiteInversor.trifasicoMais380 === null ||
          this.premissasSistema.combKitLimiteInversor.trifasicoMais380 === undefined
        )
          return;
        else
          this.premissasSistema.combKitLimiteInversor.trifasicoMais380 = Number(
            this.premissasSistema.combKitLimiteInversor.trifasicoMais380
          );

        if (this.premissasSistema.qtdMaxFormPag === null || this.premissasSistema.qtdMaxFormPag === undefined)
          this.premissasSistema.qtdMaxFormPag = 0;
        else this.premissasSistema.qtdMaxFormPag = Number(this.premissasSistema.qtdMaxFormPag);

        this.carregandoService.mostra('salvaPremissasSistema');
        await this.premissasService.salvarPremissasSistema(this.premissasSistema).toPromise();
        this.cacheService.clearCachedResponse();
        this.buscarPremissasSistema();
      } catch (erro) {
        this.notificacaoService.erro(erro);
      } finally {
        this.carregandoService.esconde('salvaPremissasSistema');
      }
    }

    this.carregandoService.mostra('salvaPremissas');

    this.premissas.essl = this.cSSL ? '1' : '0';
    this.premissas.etls = this.cTLS ? '1' : '0';
    this.premissas.freteMinimo = Number(this.premissas.freteMinimo);
    this.premissas.txRural = Number(this.premissas.txRural);
    this.premissas.tipoCalculo = Number(this.premissas.tipoCalculo);
    this.premissas.validadeFidelidade = Number(this.premissas.validadeFidelidade);
    this.premissas.fornecedoresEstrutura = JSON.stringify(this.premissas.dadosFornecedoresEstrutura);

    this.premissas.qtdPainelPorFileira = Number(this.premissas.qtdPainelPorFileira);
    this.premissas.qtPainelPorFileiraGestaoKit = Number(this.premissas.qtPainelPorFileiraGestaoKit);

    this.premissas.valorArredondamento = Number(this.premissas.valorArredondamento);

    if (this.selectedFile) {
      this.premissas.imagemFidelidadeBase64 = await this.utilitarioService.toBase64(this.selectedFile);
    }

    this.itensSimFin.forEach((p) => {
      p.detalhes = p.detalhes.replace(/\n/g, '<w:br/>');
      p.parcelas = Number(p.parcelas);
    });

    this.premissas.simFin = JSON.stringify(this.itensSimFin);

    this.premissasService.salvarPremissas(this.premissas).subscribe(
      (retorno) => {
        this.carregandoService.esconde('salvaPremissas');
        this.cacheService.clearCachedResponse();

        if (notificar) this.notificacaoService.sucesso('Premissas salvas com sucesso!!!');

        this.ngOnInit();
      },
      (erro) => {
        this.carregandoService.esconde('salvaPremissas');
        this.notificacaoService.erro(erro);
      }
    );

    if (
      this.premissasUsuario.aliquotaDeImpostoReferencial !== null &&
      this.premissasUsuario.aliquotaDeImpostoReferencial !== undefined
    ) {
      this.premissasUsuario.aliquotaDeImpostoReferencial = Number(this.premissasUsuario.aliquotaDeImpostoReferencial);
    } else {
      this.premissasUsuario.aliquotaDeImpostoReferencial = 0;
    }

    if (this.premissasUsuario.aliquotaPisCofins !== null && this.premissasUsuario.aliquotaPisCofins !== undefined) {
      this.premissasUsuario.aliquotaPisCofins = Number(this.premissasUsuario.aliquotaPisCofins);
    } else {
      this.premissasUsuario.aliquotaPisCofins = 0;
    }

    if (
      this.premissasUsuario.percentualFreteServico !== null &&
      this.premissasUsuario.percentualFreteServico !== undefined
    ) {
      this.premissasUsuario.percentualFreteServico = Number(this.premissasUsuario.percentualFreteServico);
    } else {
      this.premissasUsuario.percentualFreteServico = 0;
    }

    if (
      this.premissasUsuario.percentualMarkupMinimo !== null &&
      this.premissasUsuario.percentualMarkupMinimo !== undefined
    ) {
      this.premissasUsuario.percentualMarkupMinimo = Number(this.premissasUsuario.percentualMarkupMinimo);
    } else {
      this.premissasUsuario.percentualMarkupMinimo = 0;
    }

    this.carregandoService.mostra('salvarPremissasUsuario');
    this.premissasService.salvarPremissasUsuario(this.premissasUsuario).subscribe(
      () => {
        this.cacheService.clearCachedResponse();
        this.carregandoService.esconde('salvarPremissasUsuario');
        this.buscarPremissasUsuario();
      },
      (erro) => {
        this.carregandoService.esconde('salvarPremissasUsuario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  validarFormulario() {
    return this.carregando;
  }

  produtosFidelidade() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ProdutoFidelidadeModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  pontosFidelidade() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(PontosFidelidadeModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: { regra: this.premissas.regraFidelidade },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  abrirAtualizaProduto(tipo: number, usarFornecedores?) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(AtualizarProdutosModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        tipo: tipo,
        usarFornecedores: usarFornecedores
      },
      panelClass: 'modal-card'
    });
  }

  buscarVendedores() {
    this.carregandoService.mostra('buscarVendedores');

    this.funcionarioService.consultarTodosFuncionarios().subscribe(
      (dados) => {
        this.vendedores = dados;
        this.carregandoService.esconde('buscarVendedores');
      },
      (erro) => {
        this.carregandoService.esconde('buscarVendedores');
        this.notificacaoService.erro(erro);
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  buscarModulosAtivos() {
    this.carregandoService.mostra('buscarModulosAtivos');

    this.premissasService.consultarModulosAtivos().subscribe(
      (dados) => {
        this.modulosAtivos = dados;
        this.carregandoService.esconde('buscarModulosAtivos');
      },
      (erro) => {
        this.carregandoService.esconde('buscarModulosAtivos');
        this.notificacaoService.erro(erro);
      }
    );
  }

  onFileChanged(event) {
    this.premissas.imagemFidelidade = '';
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.premissas.imagemFidelidade = '';
    this.premissas.imagemFidelidadeBase64 = '';
  }

  abrirModalSignatarios() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(SignatariosModalComponent, {
      width: largura > 1000 ? '1020px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalArquivoProposta() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ArquivoPropostaModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalTransferenciaVendedor() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(TransferenciaItemsVendedorModalComponent, {
      width: largura > 950 ? '900px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalArquivoTermo() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ArquivoTermoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalArquivoResumoPedido() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ArquivoResumoPedidoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalItensConversa() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ItemConversaModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  abrirModalQuestionario() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(QuestionarioEntregaModalComponent, {
      width: largura > 830 ? '900px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  // simulador financeiro
  novoSimFin() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ItemSimFinModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: { simFin: new ItemSimuladorFinanceiro() },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ItemSimuladorFinanceiro) => {
      if (result) {
        // if (this.itensSimFin.some(p => Number(p.parcelas) === Number(result.parcelas))) {
        //   swal({
        //     title: 'ATENÇÃO!',
        //     text: 'Já existe um registro com a mesma quantidade de parcelas!!',
        //     type: 'warning',
        //     showCancelButton: false
        //   });
        // } else {
        this.itensSimFin.push(result);
        this.ordenaSimFin();
        // }
      }
    });
  }

  editarSimFin(simFin: ItemSimuladorFinanceiro) {
    const largura = Number($('body').width());
    const simFinParaEditar = new ItemSimuladorFinanceiro();
    Object.assign(simFinParaEditar, simFin);

    const dialogRef = this.dialog.open(ItemSimFinModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: { simFin: simFinParaEditar },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ItemSimuladorFinanceiro) => {
      if (result) {
        // if (result.parcelas !== simFin.parcelas && this.itensSimFin.some(p => p.parcelas === result.parcelas)) {
        //   swal({
        //     title: 'ATENÇÃO!',
        //     text: 'Já existe um registro com a mesma quantidade de parcelas!!',
        //     type: 'warning',
        //     showCancelButton: false
        //   });
        // } else {
        simFin.parcelas = result.parcelas;
        simFin.iof = result.iof;
        simFin.taxa = result.taxa;
        simFin.banco = result.banco;
        simFin.desconto = result.desconto;
        simFin.detalhes = result.detalhes;
        // this.ordena(this.campoOrdenacao, true);
        // }
      }
    });
  }

  excluirSimFin(simFin: ItemSimuladorFinanceiro) {
    this.itensSimFin.splice(this.itensSimFin.indexOf(simFin), 1);
  }

  ordenaSimFin() {
    this.itensSimFin = this.itensSimFin.sort((a, b) => {
      return this.compare(a.parcelas, b.parcelas, true);
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    if (a > b) {
      return +1 * (isAsc ? 1 : -1);
    }

    if (a < b) {
      return -1 * (isAsc ? 1 : -1);
    }

    return 0;

    // return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  ordena(campo) {}

  async onFileChangedImageIdVisual(controllerUrl, event) {
    const arquivo = event.target.files[0];

    if (arquivo) {
      const arquivoBase64 = await this.utilitarioService.toBase64(arquivo);
      this.enviarArquivoIdentidadeVisual(controllerUrl, arquivoBase64);
    }
  }

  enviarArquivoIdentidadeVisual(controllerUrl, arquivoBase64) {
    this.carregandoService.mostra('enviarArquivoIdentidadeVisual');

    this.identidadeVisualService.salvarArquivo(controllerUrl, arquivoBase64).subscribe(
      (resposta) => {
        this.carregandoService.esconde('enviarArquivoIdentidadeVisual');
        this.notificacaoService.sucesso('Arquivo enviado com sucesso!!');
        this.buscarIdentidadeVisual();
      },
      (erro) => {
        this.carregandoService.esconde('enviarArquivoIdentidadeVisual');
        this.notificacaoService.erro('Não foi possível enviar o arquivo!!');
      }
    );
  }

  addIp(e) {
    const ip = [];
    this.premissasSistema.ipsLiberadosApiErp.concat(ip);

    for (const x of ip) {
      this.addCustomIp(x);
    }
  }

  addCustomIp = (term) => ({ id: term, name: term });

  importarTokensExistentesComoSolicitacao(event) {
    if (!event.target.checked) return;

    this.carregandoService.mostra('importarTokensExistentesComoSolicitacao');

    this.clienteService.importarTokensExistentesComoSolicitacao().subscribe(
      () => {
        this.carregandoService.esconde('importarTokensExistentesComoSolicitacao');
        this.notificacaoService.sucesso('Tokens transferidos para sistema de solicitações com sucesso!!');
      },
      (erro) => {
        this.carregandoService.esconde('importarTokensExistentesComoSolicitacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  configurarIndicadoresMarkup() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(IndicadoresAnaliseDescontoModalComponent, {
      width: largura > 1030 ? '1000px' : $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  alterarCentrodeDistribuicaoEmMassa(habilitar) {
    this.carregandoService.mostra('alteraCentrodeDistribuicaoEmMassa');

    const data = new Date(Date.now()).toLocaleString('pt-BR');
    this.premissasUsuario.logCentroDistribuicao = `${this.usuarioLogado.nome} | ${data}`;
    this.premissasUsuario.alterarCentrodeDistribuicaoEmMassa = habilitar;

    this.funcionarioService.alterarCDEmMassa(habilitar).subscribe(
      () => {
        this.carregandoService.esconde('alteraCentrodeDistribuicaoEmMassa');
        this.notificacaoService.sucesso(
          `Comando ${this.premissasUsuario.alterarCentrodeDistribuicaoEmMassa ? 'ativado' : 'desativado'} com sucesso!!`
        );
        this.salvar(false);
      },
      (erro) => {
        this.carregandoService.esconde('alteraCentrodeDistribuicaoEmMassa');
        this.notificacaoService.erro(erro);
      }
    );
  }
}
